import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { Loader2 } from 'lucide-react';

export interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'muted' | 'white';
  label?: string;
}

const sizeMap: Record<string, number> = {
  sm: 16,
  md: 24,
  lg: 32,
};

const variantStyles: Record<string, string> = {
  primary: 'text-primary',
  muted: 'text-muted-foreground',
  white: 'text-white',
};

export const Loader = forwardRef<HTMLDivElement, LoaderProps>(
  (
    {
      size = 'md',
      variant = 'primary',
      label = 'Loading',
      className = '',
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        role="status"
        aria-label={label}
        className={[
          'inline-flex items-center justify-center',
          variantStyles[variant],
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...props}
      >
        <Loader2
          className="animate-spin"
          size={sizeMap[size]}
        />
        <span className="sr-only">{label}</span>
      </div>
    );
  },
);

Loader.displayName = 'Loader';
